<template>
    <div class="report__builder_form">
        <form-text
            :required="true"
            :label="'Name'"
            :name="'report-builder-form-name'"
            :v-validate="{ required: true }"
            :data-vv-as="'name'"
            v-model="reportName"
        ></form-text>
        <form-textarea
            :label="'Description'"
            :required="true"
            :v-validate="{ required: true }"
            :name="'report-builder-form-description'"
            v-model="reportDescription"
        ></form-textarea>
        <div class="report__builder_form_area">
            <form-radio
                :class="'report__builder_form_area report__builder_form_area--feedback'"
                :required="true"
                :label="'1. Reporting area'"
                :name="'report-builder-form-type-feedback'"
                :disabled="!isAddMode"
                :data-vv-as="'type'"
                :items="user.isSuperadmin() || user.isMasterAdministrator() || user.isLearningExperienceAdministrator() ? [
                    {
                        name: 'Feedback',
                        value: 'feedback'
                    }
                ] : []"
                :hint-position-top="true"
                :value="(reportArea === 'courseFeedbacks' || reportArea === 'trainers') ? 'feedback' : ''"
                @input="setReportArea('courseFeedbacks')"
            >Select your report type.
            </form-radio>
            <template v-if="user.isSuperadmin() || user.isMasterAdministrator() || user.isLearningExperienceAdministrator()">
                <component-wrapper
                    :class="`report__builder_form_area_wrapper report__builder_form_area_wrapper--feedback`"
                    :overlay="true"
                >
                    <form-radio
                        :class="'report__builder_form_area report__builder_form_area--feedback-specific'"
                        :required="true"
                        :label="''"
                        :name="'report-builder-form-type-feedback-specific'"
                        :disabled="!isAddMode"
                        :data-vv-as="'type'"
                        :items="[
                        {
                            name: 'Courses',
                            value: 'courseFeedbacks'
                        },
                        {
                            name: 'Trainer',
                            value: 'trainers'
                        }
                    ]"
                        :hint-position-top="true"
                        :value="reportArea"
                        @input="setReportArea"
                    >
                    </form-radio>
                </component-wrapper>
            </template>
            <form-radio
                :class="'report__builder_form_area report__builder_form_area--event-bookings'"
                :required="true"
                :label="''"
                :name="'report-builder-form-type-other'"
                :disabled="!isAddMode"
                :data-vv-as="'type'"
                :v-validate="{ required: true }"
                :items="[
                {
                    name: 'Event bookings',
                    value: 'bookings'
                }
            ]"
                :hint-position-top="true"
                :value="reportArea"
                @input="setReportArea"
            >
            </form-radio>
            <template v-if="user.isSuperadmin() || user.isMasterAdministrator() || user.isLearningExperienceAdministrator()">
                <form-radio
                    :class="'report__builder_form_area report__builder_form_area--digital-learning'"
                    :required="true"
                    :label="''"
                    :name="'report-builder-form-type-other'"
                    :disabled="!isAddMode"
                    :data-vv-as="'type'"
                    :v-validate="{ required: true }"
                    :items="[
                {
                    name: 'Digital learning activity',
                    value: 'digitalLearningActivity'
                }
            ]"
                    :hint-position-top="true"
                    :value="(reportArea === 'enrolments' || reportArea === 'moduleActivity') ? 'digitalLearningActivity' : ''"
                    @input="setReportArea('enrolments')"
                >
                </form-radio>
                <component-wrapper
                    :class="`report__builder_form_area_wrapper report__builder_form_area_wrapper--digitallearningactivity`"
                    :overlay="true"
                >
                    <form-radio
                        :class="'report__builder_form_area report__builder_form_area--digitallearningactivity-specific'"
                        :required="true"
                        :label="''"
                        :name="'report-builder-form-type-digitallearningactivity-specific'"
                        :disabled="!isAddMode"
                        :data-vv-as="'type'"
                        :items="[
                    {
                        name: 'Course completion',
                        hint: 'High level report showing completion status for multiple courses',
                        value: 'enrolments'
                    },
                    {
                        name: 'Module completion',
                        hint: 'Choose a course to view the completion status for all modules within the course',
                        value: 'moduleActivity'
                    }
                ]"
                        :hint-position-top="true"
                        :value="reportArea"
                        @input="setReportArea"
                    >
                    </form-radio>
                </component-wrapper>
            </template>
        </div>
        <template v-if="false">
            <form-select
                v-if="reportArea === 'courseFeedbacks' || reportArea === 'trainers'"
                :data-vv-as="'course'"
                :get-pagination-getter="reportArea === 'courseFeedbacks' ? 'getEbsCoursesPagination' : 'getEventsPagination'"
                :get-items-getter="reportArea === 'courseFeedbacks' ? 'getEbsCoursesReleasedMappedIdNameStatus' : 'getEventsMappedIdNameStatus'"
                :get-items-getter-mapped="reportArea === 'courseFeedbacks' ? 'getEbsCoursesReleasedMappedLabelValue' : 'getEventsMappedLabelValue'"
                :get-items-dispatch="reportArea === 'courseFeedbacks' ? 'ebsCoursesGetReleased' : 'getEvents'"
                :item-name="reportArea === 'courseFeedbacks' ? ['course', 'courses'] : ['event', 'events']"
                :label="`2. Select ${ reportArea === 'courseFeedbacks' ? 'courses' : 'events'}`"
                :name="`report-builder-form-type-other-${reportArea}`"
                :search-queryable="true"
                :table-labels="reportArea === 'courseFeedbacks' ? [
                {
                    key: 'name',
                    title: 'Course name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                }
            ] : [
                {
                    key: 'name',
                    title: 'Name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'status',
                    title: 'Status',
                    type: 'string',
                    sortable: true,
                    queryable: true
                }
            ]"
                :value="reportIds"
                :multiple="true"
                @input="setReportIds"
                @input-table="setReportIds"
            >Select the {{ reportArea === 'courseFeedbacks' ? 'courses' : 'events' }} you wish to see
            </form-select>
        </template>
        <form-select-columns
            :disabled="requestPending || !reportArea"
            :label="`2. Select columns`"
            :name="'report-builder-form-columns'"
            :required="true"
            :data-vv-as="'columns'"
            :v-validate="{ required: true }"
            :hint-position-top="true"
            :value="reportColumns"
            :disabled-values="[
                'App\\Domain\\Reports\\CourseFeedbacks\\Nodes\\Columns\\QuestionsAndAnswers',
                'App\\Domain\\Reports\\Trainers\\Nodes\\Columns\\QuestionsAndAnswers'
            ]"
            :items="listAvailableColumns"
            @emit-add="reportBuilderColumnsAdd"
            @emit-remove="reportBuilderColumnsRemove"
            @emit-move="reportBuilderColumnsMove"
        >Select the columns you want to include in your report, you can reorder them once selected.
        </form-select-columns>
        <form-select
            v-if="reportArea === 'moduleActivity'"
            :data-vv-as="'course'"
            :get-pagination-getter="'getEbsCoursesPagination'"
            :get-items-getter="'getEbsCoursesMappedIdNameStatusLabels'"
            :get-items-getter-mapped="'getEbsCoursesMappedLabelValue'"
            :get-items-dispatch="'ebsCoursesGetAdmin'"
            :get-items-dispatch-data="{ workspaceId: loggedInUserWorkspaceId }"
            :item-name="['course', 'courses']"
            :label="`3. Select courses`"
            :name="`report-builder-form-type-other-${reportArea}`"
            :search-queryable="true"
            :table-labels="[
                {
                    key: 'name',
                    title: 'Course name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                }
            ]"
            :value="reportFiltersSpecificCatalogItemId"
            :prevent-clear="true"
            :v-validate="{ required: true }"
            :multiple="false"
            @input="reportBuilderSetFilterCourseId"
            @input-table="reportBuilderSetFilterCourseId"
        >Choose your course
        </form-select>
        <form-select-filters
            :disabled="requestPending || !reportArea"
            :label="`${reportArea === 'moduleActivity' ? '4' : '3' }. Select filters`"
            :name="'report-builder-form-columns'"
            :hint-position-top="true"
            :value="reportFiltersOutput"
            :items="listAvailableReportFilters"
            @emit-add="reportBuilderFiltersAdd"
            @emit-remove="reportBuilderFiltersRemove"
        >Choose your filters.
        </form-select-filters>
        <template v-if="!isShowMode">
            <component-wrapper>
                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'report-builder-form-submit'"
                            :animate-loading="true"
                            :animate-loading-event-name="'report-builder-submit'"
                            @click="performSubmitValidate"
                        >{{ isAddMode ? 'Create and run' : 'Save and run' }}
                        </component-button>
                    </div>
                </div>
            </component-wrapper>
        </template>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import FormTextarea from '@/components/default/forms/FormTextarea'
import PopNotify from '@/components/default/shared/PopNotify'
import { performReset, performSubmitValidate, validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import FormRadio from '@/components/default/forms/FormRadio'
import FormSelectColumns from '@/components/default/forms/FormSelectColumns'
import FormSelectFilters from '@/components/default/forms/FormSelectFilters'
import FormNumber from '@/components/default/forms/FormNumber'
import FormDate from '@/components/default/forms/FormDate'
import FormSelect from '@/components/default/forms/FormSelect'
import ComponentTextButton from '@/components/default/shared/ComponentTextButton'
import { toCapitalize, toISODateUTC } from '@/functions'
import { emailRegex } from '@/variables'
import FormNotification from '@/components/default/forms/FormNotification'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import { User } from '@/User'

export default {
  name: 'report-builder-form',
  components: { FormCheckbox, FormNotification, ComponentTextButton, FormSelect, FormDate, FormNumber, FormSelectFilters, FormSelectColumns, FormRadio, ComponentWrapper, ComponentButton, PopNotify, FormTextarea, FormText },
  data () {
    return {
      requestPending: false,
      dataRecipient: '',
      emailRegex,
      user: new User()
    }
  },
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  computed: {
    loggedInUserWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    reportId () {
      return this.$store.getters.getEbsReportBuilderId
    },
    reportName: {
      get () {
        return this.$store.getters['getEbsReportBuilderName']
      },
      set (value) {
        this.$store.dispatch('ebsReportBuilderSetName', value)
      }
    },
    reportDescription: {
      get () {
        return this.$store.getters['getEbsReportBuilderDescription']
      },
      set (value) {
        this.$store.dispatch('ebsReportBuilderSetDescription', value)
      }
    },
    reportArea: {
      get () {
        return this.$store.getters['getEbsReportBuilderReport']
      }
    },
    reportIds: {
      get () {
        return this.$store.getters['getEbsReportBuilderIds']
      }
    },
    reportColumns: {
      get () {
        return this.$store.getters['getEbsReportBuilderOutput']
      }
    },
    reportFilters: {
      get () {
        return this.$store.getters['getEbsReportBuilderFilters']
      }
    },
    reportFiltersSpecificCatalogItemId: {
      get () {
        return this.$store.getters.getEbsReportBuilderFiltersSpecificValue('App\\Domain\\Reports\\ModuleActivity\\Nodes\\Columns\\CatalogItemId')
      }
    },
    reportScheduleRecipients: {
      get () {
        return this.$store.getters['getEbsReportBuilderScheduleRecipients']
      }
    },
    reportForceReport: {
      get () {
        return this.$store.getters['getEbsReportBuilderForceReport']
      }
    },
    reportFiltersOutput () {
      const workspaceOrgUnits = this.workspaceOrgUnits
      let reportFilters = JSON.parse(JSON.stringify(this.reportFilters))
      let orgUnitReportFilters = reportFilters.filter(obj => obj.column.includes('OrganisationUnit'))

      if (orgUnitReportFilters.length) {
        for (let filter of orgUnitReportFilters) {
          const filterValue = filter.threshold.value
          const selectedOrgUnit = workspaceOrgUnits.find(fObj => fObj.id === filterValue)
          // filter.threshold.value = filterValue.map(mObj => workspaceOrgUnits.find(fObj => fObj.id === mObj)).map(obj => obj.name)
          filter.threshold.value = selectedOrgUnit ? selectedOrgUnit.name : ''
        }
      }

      return reportFilters
    },
    routeName () {
      return this.$route.name
    },
    //
    watchContent () {
      return this.reportName + this.reportDescription + this.reportArea + this.reportColumns + this.reportFilters
    },
    //
    rootItemName () {
      return 'report-builder'
    },
    nameActionCreate () {
      return 'ebsReportBuilderCreateAndExecute'
    },
    nameActionUpdate () {
      return 'ebsReportBuilderUpdateAndExecute'
    },
    paramsActionUpdate () {
      return { id: this.reportId }
    },
    nameActionReset () {
      return 'ebsReportBuilderReset'
    },
    isAddMode () {
      return this.$route.name.includes('report-builder-add')
    },
    isEditMode () {
      return this.$route.name.includes('report-builder-edit')
    },
    isShowMode () {
      return this.$route.name.includes('report-builder-show')
    },
    listAvailableColumns () {
      return this.$store.getters.getEbsReportBuilderAvailableColumnsMappedLabelValue
    },
    listAvailableReportFilters () {
      const availableColumns = this.listAvailableColumns
      const availableColumnsFiltered = availableColumns.filter(obj => obj.value !== `App\\Domain\\Reports\\ModuleActivity\\Nodes\\Columns\\CatalogItemId`)
      let availableColumnsMapped = availableColumnsFiltered.length ? availableColumnsFiltered.filter(filteredObj => filteredObj.filters.length).map(selectedObj => {
        return {
          label: selectedObj.label,
          value: selectedObj.value,
          node: selectedObj.node,
          filters: selectedObj.filters,
          dataType: selectedObj.dataType,
          availableValues: selectedObj.availableValues
        }
      }) : []

      return availableColumnsMapped
    },
    workspaceOrgUnits () {
      return this.$store.getters.getLmsSuperadminOrgUnitsMappedIdName
    }
  },
  watch: {
    reportArea (newValue, oldValue) {
      if (this.reportFilters.length && oldValue) {
        this.reportBuilderFiltersClear()
      }
      if (this.reportColumns.length && oldValue) {
        this.reportBuilderColumnsClear()
      }
      this.reportBuilderGetAvailableColumns().then(() => {
        if ((newValue === 'trainers' || newValue === 'courseFeedbacks') && this.isAddMode) {
          this.reportBuilderColumnsAdd(`App\\Domain\\Reports\\${toCapitalize(newValue)}\\Nodes\\Columns\\QuestionsAndAnswers`)
        }
      })
    }
  },
  methods: {
    performSendTestReport () {
      this.$store.dispatch('ebsReportBuilderSendTest', this.reportId).finally(() => {
        this.$eventBus.$emit('stop-send-report-test')
      })
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-report-builder-submit')
    },
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-report-builder-submit')
    },
    reportBuilderGetAvailableColumns () {
      if (this.reportArea) {
        this.requestPending = true
        return this.$store.dispatch('ebsReportBuilderGetAvailableColumns', this.reportArea).finally(() => {
          this.requestPending = false
        })
      }
    },
    reportBuilderGetAvailableReports () {
      this.requestPending = true
      this.$store.dispatch('ebsReportBuilderGetAvailableReports', this.reportArea).finally(() => {
        this.requestPending = false
      })
    },
    reportBuilderColumnsAdd (data) {
      this.$store.dispatch('ebsReportBuilderColumnsAdd', data)
    },
    reportBuilderColumnsRemove (data) {
      this.$store.dispatch('ebsReportBuilderColumnsRemove', data)
    },
    reportBuilderColumnsMove (data) {
      this.$store.dispatch('ebsReportBuilderColumnsMove', data)
    },
    reportBuilderColumnsClear (data) {
      this.$store.dispatch('ebsReportBuilderColumnsClear', data)
    },
    reportBuilderFiltersAdd (data) {
      this.$store.dispatch('ebsReportBuilderFiltersAdd', data)
    },
    reportBuilderFiltersRemove (data) {
      this.$store.dispatch('ebsReportBuilderFiltersRemove', data)
    },
    reportBuilderFiltersClear (data) {
      this.$store.dispatch('ebsReportBuilderFiltersClear', data)
    },
    reportBuilderSetFilterCourseId (data) {
      this.$store.dispatch('ebsReportBuilderFiltersSetSpecific', {
        column: 'App\\Domain\\Reports\\ModuleActivity\\Nodes\\Columns\\CatalogItemId',
        type: 'equals',
        threshold: { value: data.value }
      })
    },
    reportBuilderScheduleRecipientsAdd () {
      this.$store.dispatch('ebsReportBuilderScheduleRecipientsAdd', this.dataRecipient)
      this.dataRecipient = ''
    },
    setReportBuilderForceReport (value) {
      this.$store.dispatch('ebsReportBuilderSetForceReport', value)
    },
    setReportArea (data) {
      this.$store.dispatch('ebsReportBuilderSetReport', data)
      this.setReportIds([])
    },
    setReportIds (data) {
      this.$store.dispatch('ebsReportBuilderSetIds', data)
    }
  },
  mounted () {
    this.reportBuilderGetAvailableReports()
    this.reportBuilderGetAvailableColumns()
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportbuilderform.scss";
</style>
